import { CareAllowancePlacementHoldPopupQuestion } from "../interfaces/care-allowance-placement-hold-popup-question.interface";

export class CareAllowancePlacementHoldRequest implements CareAllowancePlacementHoldPopupQuestion {
  constructor(
    public placementId: string,
    public placementHoldReasonTypeId: string,
    public placementHoldComments: string
  ) { }
}
